import axios from 'axios';
import Api from './Api';

const { CancelToken } = axios;

let cancelRead;
class StmsRequestApi extends Api {
  constructor() {
    super('stms/requests', 'stms/requests');
  }

  async readData(data) {
    if (cancelRead !== undefined) {
      cancelRead();
    }
    const res = await this.read(data, {
      cancelToken: new CancelToken((c) => {
        cancelRead = c;
      }),
    });
    return res;
  }
}
const stmsRequestApi = new StmsRequestApi();

export default stmsRequestApi;
